import styled from 'styled-components/macro';
import { wide } from '../../styling/spacing';
import { ErrorBox } from '../ErrorBox';

export const FormErrorBox = styled(ErrorBox)`
  margin: ${wide} 0;
`;
